// extracted by mini-css-extract-plugin
export default {"title":"EmailModal_title__KWKT+","subTitle":"EmailModal_subTitle__L-E8E","emailModalContent":"EmailModal_emailModalContent__5fskF"};